import { getNeededDateFormat } from '../index'

const FORBIDDEN = /[\\/:*?"<>|]/g

export const buildZReportPdfFilename = (report) => {
	const safeZNumber = String(report.zNumber).replace(FORBIDDEN, '_')
	const datePart = getNeededDateFormat(report.timeEnd, 'yyyy-MM-dd')
	return `Z-Bericht_${safeZNumber}_${datePart}.pdf`
}
